module.exports = __webpack_public_path__ + "static/Softimage-b7358bfd91732fe191757d8b76482ec8.png";